import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { putOrganization } from '../../../api/organizations';

import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const updateOrganization = createAsyncThunk(
  'organizations/updateOrganization',
  async ({ path, body }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await putOrganization(
        { path, body },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition({ path: { orgId } }, { getState }) {
      const { organizations } = getState().organizations;

      return (
        organizations.organization.actions.update.request[orgId]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const updateOrganizationExtraReducers = builder => {
  builder
    .addCase(updateOrganization.pending, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      checkAndSetLoadingWithId(
        state.organizations.organization.actions.update.request,
        action,
        organizationId,
      );
    })
    .addCase(updateOrganization.fulfilled, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      onMatchedRequest(
        state.organizations.organization.actions.update.request[organizationId],
        action,
        () => {
          state.organizations.organization.byId[organizationId] =
            action.payload;
          if (
            !state.organizations.organization.allIds.includes(organizationId)
          ) {
            state.organizations.organization.allIds.push(organizationId);
          }
        },
      );
    })
    .addCase(updateOrganization.rejected, (state, action) => {
      const organizationId = action.meta.arg.path.orgId;
      handleRequestRejection(
        state.organizations.organization.actions.update.request[organizationId],
        action,
      );
    });
};
